import { Container } from '@/atoms';
import { CardBlog, ProductBlock, SliderCard } from '@/molecules';

import { config } from '@/config';
import { routes } from '@/lib';
import {
  getImageWithFallBackWithOutAlt,
  getRealUrl,
  sectionBgProps,
  textStyleClass,
} from '@/utils';

/**
 * ComponentRevisadasBlogDestacados
 */
export const ComponentRevisadasBlogDestacados = ({
  Titulo,
  Descripcion,
  TituloEstilo,
  DescripcionEstilo,
  blog_posts,
  FondoSeccion,
}: any) =>
  blog_posts?.length ? (
    <Container wrapper {...sectionBgProps(FondoSeccion, 'bg-primary-50')}>
      <ProductBlock
        title={Titulo}
        description={Descripcion}
        titleStyleClass={textStyleClass(TituloEstilo)}
        descriptionStyleClass={textStyleClass(DescripcionEstilo)}
      >
        <SliderCard
          link={{ label: 'Ver todas', href: routes.blog.index }}
          perPage={3}
          breakpoints={{
            1024: {
              perPage: 3,
            },
            768: {
              padding: 38,
              perPage: 2,
              gap: 16,
            },
            500: {
              padding: 30,
              perPage: 1,
            },
          }}
        >
          {blog_posts.map((itm: any, index: number) => (
            <CardBlog
              key={`card-blog-${index}`}
              image={{
                alt: itm?.post?.ImagenPrincipal?.alternativeText || itm.Titulo,
                src: getImageWithFallBackWithOutAlt(
                  getRealUrl(itm?.post?.ImagenPrincipal?.url),
                  config.fallbackImage,
                ),
              }}
              title={itm.Titulo}
              description={itm.Descripcion}
              tag={itm.post.category.category}
              link={{
                label: 'Saber más',
                href: itm.slug,
              }}
              className="h-full"
            />
          ))}
        </SliderCard>
      </ProductBlock>
    </Container>
  ) : null;

ComponentRevisadasBlogDestacados.displayName =
  'ComponentRevisadasBlogDestacados';
